import { useContext } from 'react';
import { CommissionSessionPageContext, CommissionSessionPageContextType } from '../../contexts';

export function useCommissionSessionPageContext(): CommissionSessionPageContextType {
    return useContext(CommissionSessionPageContext);
}
